module.exports = __webpack_public_path__ + "img/abc.813c9457.svg";